import type { dataOptions } from './types/data';
import { getRequest } from '../services/http';

export const searchProducts = async (data: dataOptions) => {
  const response = await getRequest({
    url: `branch-stores/${data.id}/products/?search=${data.term}`,
  });

  return response;
};

export const retreiveBranchStoreDetail = async (data: dataOptions) => {
  const response = await getRequest({
    url: `branch-stores/${data.id}/`,
  });

  return response;
};

export const retreiveBranchStoreSchedule = async (data: dataOptions) => {
  const response = await getRequest({
    url: `branch-stores/${data.id}/schedules/`,
  });

  return response;
};

export const retreiveBranchStoreScheduleProccessOrder = async (data: dataOptions) => {
  const response = await getRequest({
    url: `branch-stores/${data.id}/delivery-schedules/`,
    protected: true,
  });

  return response;
};

export const retreiveBranchStoreNearby = async (data: dataOptions) => {
  const response = await getRequest({
    url: `branch-stores/nearby/?store_id=${data.id}`,
    protected: true,
    sessionCookie: data.sessionCookie,
  });

  return response;
};
